/**
 * Helper invalidation cache lintas-domain.
 *
 * Pemakaian umum (di setup) — biasanya setelah mutation yang berdampak ke beberapa domain:
 *
 *   const invalidate = useInvalidate();
 *   await someMutation.mutateAsync(payload);
 *   invalidate.international();   // refetch semua list/detail international order
 *   invalidate.finance();         // refetch semua finance
 *   invalidate.everything();      // nuclear option — refetch semua
 */
import { useQueryClient } from "@tanstack/vue-query";
import { keys } from "@/queries/keys";

export function useInvalidate() {
  const qc = useQueryClient();
  return {
    master: () => qc.invalidateQueries({ queryKey: keys.master.all }),
    users: () => qc.invalidateQueries({ queryKey: keys.users.all }),
    international: () =>
      qc.invalidateQueries({ queryKey: keys.international.all }),
    domestic: () => qc.invalidateQueries({ queryKey: keys.domestic.all }),
    booking: () => qc.invalidateQueries({ queryKey: keys.booking.all }),
    finance: () => qc.invalidateQueries({ queryKey: keys.finance.all }),
    report: () => qc.invalidateQueries({ queryKey: keys.report.all }),
    tracking: () => qc.invalidateQueries({ queryKey: keys.tracking.all }),
    store: () => qc.invalidateQueries({ queryKey: keys.store.all }),
    everything: () => qc.invalidateQueries(),
    /* Granular: invalidate berdasarkan key apapun */
    byKey: (queryKey) => qc.invalidateQueries({ queryKey }),
    /* Akses raw queryClient */
    client: qc,
  };
}

export default useInvalidate;
